import Footer from "./Footer";
// import Sidebar from "./Sidebar";
import React, { useEffect, useState } from "react";
import Topbar from "./Topbar";
interface Props {
    children: React.ReactNode;
  }
const Layout: React.FC<Props> = ({ children }) => {
    const [action, setAction] = useState('');
    const [row, setRow] = useState(undefined);
    function getData(page: any, pageSize: any, searchKey: any): void {
        throw new Error("Function not implemented.");
      }

    const handleRowEdit = () => {
        // setRow(rowData);
        // dispatch(setSamithi_MembersMessage(''));
        setAction('add');
      }
    return (
        <div id="wrapper">
            {/* <Sidebar></Sidebar> */}
            <div id="content-wrapper" className="d-flex flex-column mb-0">
                <div id="content">
                    
                    <Topbar handleRowEdit={handleRowEdit} hideShowForm={setAction} action={action} row={row} getData={getData}></Topbar>
                    {children}
                </div>
                <Footer></Footer>
            </div>
        </div>
    );
};

export default Layout;


